export const endPoints = {
  PATCH_COMPANY_COMMENT: '/v1/contract/comment',
  GET_COMPANY_COMMENTS: '/v1/contract'
};
